<template>
    <div>
        <el-row :gutter="20">
            <h2 style="margin-top:unset;">Sorting Code - SCG</h2>
            <el-col :span="12" :offset="6">
                <el-card shadow="never" style="padding-bottom:20px;">
                    <el-row>
                        <el-col :span="6">
                            <el-input v-model="filters[0].value" placeholder="ค้นหารหัสไปรษณีย์"></el-input>
                        </el-col>
                        <el-col :span="6" style="margin-left:5px;">
                            <el-button type="primary" @click="showUpload">
                                <fa-icon name="file-excel"></fa-icon>&nbsp;Upload SortingCode
                            </el-button>
                            <input type="file" ref="uploadSorting" style="display:none;" @change="onUploadSortingCode">
                        </el-col>
                    </el-row>
                    <el-row>
                        <data-tables
                            :data="sortingList"
                            :filters="filters"
                            class="dataTable"
                            :page-size="10"
                            :pagination-props="{ pageSizes: [10, 20, 50, 100], pagerCount: 5 }"
                        >
                            <el-table-column label="รหัสไปรษณีย์" prop="zipcode" width="100">
                            </el-table-column>
                            <el-table-column label="Sorting Code" prop="sortingCode" width="150">
                            </el-table-column>
                        </data-tables>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import xlsx from 'xlsx'

export default {
    name: 'SortingCodeSCG',
    data () {
        return {
            sortingRaw: {},
            sortingList: [],
            filters: [
                { prop: 'zipcode', value: '' }
            ]
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        showUpload () {
            this.$refs.uploadSorting.click()
        },
        onUploadSortingCode (e) {
            let files = e.target.files
            let f = files[0]
            this.uploadFile = files[0]
            let parts = f.name.split('.')
            let ext = parts[parts.length - 1]
            if (ext !== 'xlsx') {
                this.$swal({
                    title: 'ผิดพลาด !',
                    text: 'ไฟล์ที่ต้องการอัพโหลดไม่ถูกต้อง',
                    type: 'error'
                })
                return
            }
            let reader = new FileReader()
            reader.onload = async (e) => {
                this.$loading()
                let data = e.target.result
                var workbook = xlsx.read(data, { type: 'binary' })
                var wsname = workbook.SheetNames[0]
                var ws = workbook.Sheets[wsname]
                var readData = xlsx.utils.sheet_to_json(ws, { header: 1 })
                let keyList = ['zipcode', 'assert_code']
                let dataArray = []
                let dataWithoutKey = readData.slice(1, readData.length)
                dataWithoutKey.forEach((row, rowIdx) => {
                    let tmpObj = {}
                    for (let index = 0; index < keyList.length; index++) {
                        tmpObj[keyList[index]] = String(row[index])
                    }
                    dataArray.push(tmpObj)
                })
                console.log(dataArray)
                console.log(dataArray.length)
                this.processSorting(dataArray)
            }
            reader.readAsBinaryString(f)
        },
        processSorting (NewSortingList) {
            // let arrNoHaveInNew = []
            // let arrNoHaveInOld = []
            // NewSortingList.forEach(e => {
            //     if (!this.sortingRaw.hasOwnProperty(e.zipcode)) {
            //         arrNoHaveInNew.push(e)
            //     }
            // })
            // this.sortingList.forEach(e => {
            //     console.log(NewSortingList.filter((o) => { return o.zipcode === e.zipcode } ))
            //     console.log(e.zipcode)
            //     NewSortingList.filter((o) => {
            //         console.log(o)
            //         return o.zipcode === e.zipcode
            //     })
            //     if (NewSortingList.filter(o => o.zipcode === e.zipcode).length === 0) {
            //         arrNoHaveInOld.push(e)
            //     }
            // })
            // console.log(arrNoHaveInNew, arrNoHaveInOld)
            this.$confirm(`<b>ข้อมูลในระบบ</b> - ${this.sortingList.length}<br><b>ข้อมูลจาก Excel</b> - ${NewSortingList.length}`, 'ตรวจสอบข้อมูลก่อนอัพโหลด !', {
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(async () => {
                let assertCode = {}
                NewSortingList.forEach(e => {
                    assertCode[e.zipcode] = e.assert_code
                })
                console.log()
                try {
                    await fgApi.courier.updateListSorting(assertCode)
                    this.fetchData()
                    this.$message({
                        type: 'success',
                        message: 'Update Sorting Code completed'
                    })
                    this.$refs.uploadSorting.value = ''
                    this.fetchData()
                } catch (error) {
                    this.$message({
                        type: 'error',
                        message: error
                    })
                }
                this.$loading().close()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
                this.$loading().close()
            })
        },
        async fetchData () {
            this.sortingList = []
            this.sortingRaw = {}
            try {
                let res = await fgApi.courier.getListSorting()
                this.sortingRaw = res.assertCode
                for (const key in res.assertCode) {
                    this.sortingList.push({
                        zipcode: key,
                        sortingCode: res.assertCode[key]
                    })
                }
            } catch (error) {
                console.log(error)
                this.$notify.error({
                    title: 'Error',
                    message: 'Get courier sorting error'
                })
            }
        }
    }
}
</script>
